<template>
  <div style="padding: 20px">
    <v-card>
      <v-toolbar class="indigo white--text" dense primary-title>
        <v-toolbar-title>{{
          "Dettaglio " +
          (codDocumento == "PLCG" ? "Placing " : "Picking ") +
          codPicking
        }}</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              :disabled="codDocumento != 'ORDP'"
              v-on="on"
              small
              elevation="1"
              class="ml-10"
              @click="changeView"
            >
              <v-icon color="primary">
                {{ viewMode == 0 ? "mdi-file-cog-outline" : "mdi-dolly" }}
              </v-icon>
            </v-btn>
          </template>
          <span
            >{{ viewMode == 0 ? "Visualizza Commessa" : "Visualizza Articoli" }}
          </span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              class="ml-10"
              :disabled="!enableTermina"
              @click="terminaDialog = true"
            >
              <v-icon color="error"> mdi-close </v-icon>
            </v-btn>
          </template>
          <span>Termina Ordine</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              class="ml-10"
              @click="toggleFilters"
            >
              <v-icon color="purple"> mdi-filter </v-icon>
            </v-btn>
          </template>
          <span>Filtri</span>
        </v-tooltip>

        <!-- Bottone di salvataggio -->
        <!--<v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" small elevation="1" @click="salvaPicking">
              <v-icon class="success--text"> mdi-floppy </v-icon>
            </v-btn>
          </template>
          <span>Salva Distinta</span>
        </v-tooltip>-->

        <v-spacer></v-spacer>
        <!-- Bottone di gestione pedane
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              small
              v-bind="attrs"
              v-on="on"
              @click="gestisciPedane"
            >
              <v-icon color="primary"> mdi-cart </v-icon>
            </v-btn>
          </template>
          <span>Gestisci Contenitori</span>
        </v-tooltip> -->

        <!-- Bottone delle segnalazioni
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              v-bind="attrs"
              v-on="on"
              @click="toggleSegnalazioneSegnalazione"
            >
              <v-icon color="error"> mdi-alert </v-icon>
            </v-btn>
          </template>
          <span>Genera Segnalazione</span>
        </v-tooltip>
        <v-spacer></v-spacer> -->

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="$router.push({ name: 'HomePicking' })"
            >
              <v-icon class="error--text"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span>Indietro</span>
        </v-tooltip>
      </v-toolbar>
      <v-progress-linear
        indeterminate
        color="cyan"
        v-if="loading"
        id="progress"
      >
      </v-progress-linear>

      <v-card-text>
        <v-row v-if="showFilter">
          <v-col class="flex-grow-1 flex-shrink-0">
            <v-autocomplete
              label="Disponibilita Magazzino"
              :items="filtriM"
              dense
              outlined
              v-model="filtro_disp"
              @change="changeFilters"
              item-text="text"
              return-object
            >
            </v-autocomplete>
          </v-col>

          <v-col class="flex-grow-1 flex-shrink-0">
            <v-autocomplete
              label="Stato Prelievo"
              :items="filtriG"
              dense
              outlined
              v-model="filtro_giac"
              @change="changeFilters"
              item-text="text"
              return-object
            >
            </v-autocomplete>
          </v-col>
        </v-row>

        <v-data-table
          v-if="viewMode == 0"
          v-model="distinteSelected"
          :headers="codDocumento == 'PLCG' ? headers_placing : headers"
          item-key="descrizione"
          :items="showFilter ? filtered : lista_tabella"
          :single-select="false"
        >
          <!--<template v-slot:top>
            <v-row v-show="segnalazioneSegnalazione" class="indigo mx-0 my-0">
              <v-col>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small elevation="1" @click="salvaSegnalazione">
                      <v-icon class="success--text"> mdi-floppy </v-icon>
                    </v-btn>
                  </template>
                  <span>Genera Segnalazione</span>
                </v-tooltip>
              </v-col>
              <v-col md="auto" class="py-0">
                <v-select
                  label="Segnalazione"
                  dense
                  outlined
                  solo
                  hide-details
                  v-model="tipoSegnalazione"
                  :items="tipi_segnalazioni"
                  item-text="nome"
                  item-value="nome"
                  class="segnalazione-select mt-1"
                  style="width: 250px"
                >
                </v-select>
              </v-col>
            </v-row>
          </template>-->
          <!-- Bottone di modifica -->
          <template v-slot:[`item.modifica`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  small
                  elevation="1"
                  class="mr-3"
                  @click.stop="showEditDialog(item)"
                >
                  <v-icon color="primary"> mdi-pencil </v-icon>
                </v-btn>
              </template>
              <span>Modifica</span>
            </v-tooltip>
          </template>

          <!-- Bottone di eliminazione -->
          <template v-slot:[`item.elimina`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  small
                  elevation="1"
                  @click.stop="showDeleteArticolo(item)"
                >
                  <v-icon class="error--text">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Elimina</span>
            </v-tooltip>
          </template>

          <template v-slot:[`item.impegno`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  small
                  elevation="1"
                  @click.stop="showImpegno(item)"
                >
                  <v-icon :color="statusIconsI[item.impegno].color">{{
                    item.impegno == 1
                      ? "mdi-alpha-p-circle"
                      : item.impegno == 2
                      ? "mdi-check"
                      : "mdi-cancel"
                  }}</v-icon>
                </v-btn>
              </template>
              <span>{{ statusIconsI[item.impegno].desc }}</span>
            </v-tooltip>
          </template>

          <template v-slot:[`item.prelevata`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon :color="statusIcons[item.statoPreleva].color" v-on="on">
                  {{ statusIcons[item.statoPreleva].icon }}
                </v-icon>
              </template>
              <span>{{ statusIcons[item.statoPreleva].desc }}</span>
            </v-tooltip>
          </template>

          <template v-slot:[`item.statoPlacing`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon :color="statusIcons[item.statoPlacing].color" v-on="on">
                  {{ statusIcons[item.statoPlacing].icon }}
                </v-icon>
              </template>
              <span>{{ placingStatus[item.statoPlacing] }}</span>
            </v-tooltip>
          </template>

          <template v-slot:[`item.posizione`]="{ item }">
            <v-tooltip bottom v-if="item.statoDisponibilita != 0">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  small
                  elevation="1"
                  @click="showPosizioni(item)"
                >
                  <v-icon
                    :color="
                      item.statoDisponibilita == 1
                        ? 'yellow accent-4'
                        : 'success'
                    "
                  >
                    {{
                      item.statoDisponibilita == 1
                        ? "mdi-alpha-p-circle"
                        : "mdi-check"
                    }}
                  </v-icon>
                </v-btn>
              </template>
              <span>{{
                item.statoDisponibilita == 1
                  ? "Parzialmente disponibile"
                  : "Completamente disponibile"
              }}</span>
            </v-tooltip>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on }">
                <v-icon color="error" v-on="on"> mdi-cancel </v-icon>
              </template>
              <span>Articolo non in Magazzino</span>
            </v-tooltip>
          </template>

          <template v-slot:[`item.giacenza`]="{ item }">
            <v-tooltip bottom v-if="item.qta_prelevata > 0">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  small
                  elevation="1"
                  @click="showGiacenza(item)"
                >
                  <v-icon :color="statusIcons[item.statoPreleva].color">
                    {{
                      item.statoPreleva == 1
                        ? "mdi-alpha-p-circle"
                        : "mdi-check"
                    }}
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ statusIcons[item.statoPreleva].desc }}</span>
            </v-tooltip>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on }">
                <v-icon color="error" v-on="on"> mdi-cancel </v-icon>
              </template>
              <span>{{ statusIcons[item.statoPreleva].desc }}</span>
            </v-tooltip>
          </template>

          <template v-slot:[`item.segnalazione`]="{ item }">
            <v-tooltip bottom v-if="item.segnalazione">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  small
                  elevation="1"
                  @click="showSegnalazione(item)"
                >
                  <v-icon color="error"> mdi-alert </v-icon>
                </v-btn>
              </template>
              <span>Segnalazione Generata</span>
            </v-tooltip>
          </template>
        </v-data-table>

        <v-data-table
          v-else
          :headers="commessaHeaders"
          :items="showFilter ? filtered : lista_tabella"
        >
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="terminaDialog" width="400">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">
            Termina Ordine
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="terminaDialog = false" small>
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-row dense class="pt-2">
            <v-col cols="6">
              <v-btn block @click="terminaForzata" class="pa-2">
                Chiusura Forzata
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn block @click="terminaJSON" class="pa-2">
                Genera JSON
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="segnalazioneDettaglio" width="550">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">
            Dettaglio Segnalazione
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="segnalazioneDettaglio = false" small>
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-progress-linear
          indeterminate
          color="cyan"
          v-if="loading"
          id="progress"
        >
        </v-progress-linear>

        <v-tabs v-model="selectedTab">
          <v-tab key="generale">Generale</v-tab>
          <v-tab key="allegati">Allegati</v-tab>
        </v-tabs>

        <v-tabs-items v-model="selectedTab">
          <v-tab-item key="generale">
            <v-card-text class="pa-2">
              <v-col>
                <v-row class="my-2">
                  <v-col cols="6">
                    <v-row align="center" justify="center">
                      <h3 style="font-weight: normal">Tipo:</h3>
                      <h3>{{ tipi_segnalazione[tempSegnalazione.tipo].desc }}</h3>
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <v-row align="center" justify="center">
                      <h3 style="font-weight: normal">Quantita:</h3>
                      <h3>{{ tempSegnalazione.quantita }}</h3>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="my-2">
                  <v-col cols="12">
                    <v-row align="center" justify="center">
                      <h3 style="font-weight: normal">Segnalato da:</h3>
                      <h3>{{ tempSegnalazione.nome_utente }}</h3>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="my-2">
                  <v-col cols="12">
                    <v-row align="center" justify="center">
                      <h3 style="font-weight: normal">Note:</h3>
                      <h3>{{ tempSegnalazione.note }}</h3>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-card-text>
          </v-tab-item>
          <v-tab-item key="allegati">
            <v-tabs v-model="allegatiTab">
              <v-tab v-for="(item, index) in immagini" :key="index">
                {{ "Allegato " + (index + 1) }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="allegatiTab">
              <v-tab-item v-for="(item, index) in immagini" :key="index">
                <v-card max-height="60vh" class="overflow-y-auto">
                  <img :src="item.immagine" width="500" />
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>

    <!--<v-dialog v-model="generazioneSegnalazione" width="500">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">
            Generazione Segnalazione
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="salvaSegnalazione" small>
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="generazioneSegnalazione = false" small>
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="pa-2">
          <v-col>
            <v-row>
              <v-col cols="5">
                <v-autocomplete
                  label="articolo"
                  :items="articoli"
                  item-text="cod_articolo"
                  item-value="id_documento_dettaglio"
                  v-model="tempSegnalazione.id_documento_dettaglio"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="5">
                <v-autocomplete
                  label="tipo segnalazione"
                  :items="tipi_segnalazione"
                  item-text="desc"
                  item-value="tipo"
                  v-model="tempSegnalazione.tipo"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  label="qnt"
                  type="number"
                  v-model="tempSegnalazione.quantita"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-textarea
                class="pr-2 pl-2"
                label="note"
                v-model="tempSegnalazione.note"
              >
              </v-textarea>
            </v-row>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>-->

    <v-dialog v-model="posizioneDialog" width="700">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">
            Posizioni Articolo
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="posizioneDialog = false" small>
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="pa-2">
          <v-data-table
            :headers="posizioneHeaders"
            :items="posizioni"
            sort-by="path"
          >
            <template v-slot:[`item.tipo`]="{ item }">
              {{ item.tipo == null ? "nessun tipo" : tipiPosizione[item.tipo] }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="impegnoDialog" width="700">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text"> Stato Impegno </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="impegnoDialog = false" small>
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="pa-2">
          <v-col>
            <v-row>
              <v-col cols="4">
                {{ "Quantita Magazzino: " + impegni[0].qnt_magazzino }}
              </v-col>
              <v-col cols="4">
                {{ "Quantita Impegnata: " + totImpegno }}
              </v-col>
              <v-col cols="4">
                {{ "Differenza: " + (impegni[0].qnt_magazzino - totImpegno) }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="impegnoHeaders"
                  :items="impegni"
                  disable-sort
                >
                  <template v-slot:[`item.urgenza`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" :color="urgenze[item.urgenza].color">
                          {{ urgenze[item.urgenza].icon }}
                        </v-icon>
                      </template>
                      <span>{{ urgenze[item.urgenza].desc }}</span>
                    </v-tooltip>
                  </template>

                  <template v-slot:[`item.stato`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          :color="statusIconsI[item.stato].color"
                        >
                          {{ statusIconsI[item.stato].icon }}
                        </v-icon>
                      </template>
                      <span>{{ statusIconsI[item.stato].desc }}</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="giacenzaDialog" width="500">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">
            Stato Giacenza
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="giacenzaDialog = false" small>
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="pa-2">
          <v-data-table :headers="giacenzaHeaders" :items="giacenze">
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="edit_dialog_visible" width="500">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">
            Modifica Quantità
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" small @click="salvaEditDialog">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva e Chiudi</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="chiudiEditDialog" small>
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="pa-0 pt-3">
          <v-container v-if="currentItem">
            <v-row>
              <v-col>
                <h3>Quantità da prelevare: {{ currentItem.quantita }}</h3>
              </v-col>
            </v-row>

            <v-row>
              <v-col align="center">
                <v-text-field
                  label="Quantità Prelevata"
                  dense
                  outlined
                  v-model="quantita"
                  type="number"
                  min="0"
                  :max="currentItem.quantita"
                  style="border-radius: 0px; max-width: 150px"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialogPicking"
      width="unset"
    >
      <v-card>
        <v-toolbar dense class="indigo darken-1 headline">
          <v-toolbar-title class="white--text"> Picking </v-toolbar-title>
        </v-toolbar>

        <v-card-text class="mt-6" v-if="currentItem">
          <h3 style="text-align: left !important">
            Confermi che stai prelevando l'articolo
            {{ currentItem.des_articolo }} - qnt.
            {{ currentItem.quantita_prelevata }} ?
          </h3>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="dialogPicking = false">
            ANNULLA
          </v-btn>
          <v-btn color="#4caf50" dark @click="pickingItem"> CONFERMA </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialogEliminaArticolo"
      width="unset"
    >
      <v-card>
        <v-toolbar dense class="indigo darken-1 headline">
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>

        <v-card-text class="mt-6">
          <h3 style="text-align: left !important">
            Sei sicuro di voler eliminare questo articolo?
          </h3>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="dialogEliminaArticolo = false">
            ANNULLA
          </v-btn>
          <v-btn color="#4caf50" dark @click="deleteArticolo"> CONFERMA </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog di gestione delle pedane -->
    <v-dialog persistent v-model="gestisci_pedane_dialog">
      <GestionePedane
        @click_chiudi="handleCloseGestPed"
        :id_documento="id_documento"
        :visible="gestisci_pedane_dialog"
      />
    </v-dialog>

    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import GestionePedane from "@/components/PICKING/GestionePedane.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "Picking",
  props: {
    id_documento: { type: Number, default: null },
    num_documento: {
      type: String,
      default: "",
    },
  },
  components: {
    GestionePedane,
    SnackbarQV,
  },
  data() {
    return {
      // Modal
      rag_soc: "",
      terminaDialog: false,
      enableTermina: true,
      codPicking: "",
      codDocumento: "",
      viewMode: 0,
      totImpegno: 0,
      impegnoDialog: false,
      showFilter: false,
      allegatiTab: "",
      selectedTab: "generale",
      tempCod: "",
      segnalazioneDettaglio: false,
      posizioneDialog: false,
      giacenzaDialog: false,
      currentArticolo: false,
      singleSelect: false,
      sortStatus: false,
      generazioneSegnalazione: false,
      tipoSegnalazione: null,
      currentItem: null,
      quantita: null,
      dialogPicking: false,
      edit_dialog_visible: false,
      gestisci_pedane_dialog: false,
      loading: false,
      moveAnimation: false,

      // Array
      giacenze: [],
      immagini: [{ immagine: "" }],
      filtered: [],
      filtriM: [
        {
          text: "Tutti",
          value: -1,
        },
        {
          text: "Non disponibile",
          value: 0,
        },
        {
          text: "Parzialmente disponibile",
          value: 1,
        },
        {
          text: "Completamente disponibile",
          value: 2,
        },
      ],
      filtriG: [
        {
          text: "Tutti",
          value: -1,
        },
        {
          text: "Non prelevato",
          value: 0,
        },
        {
          text: "Parzialmente prelevato",
          value: 1,
        },
        {
          text: "Completamente prelevato",
          value: 2,
        },
      ],
      filtro_giac: {
        text: "Tutti",
        value: -1,
      },
      filtro_disp: {
        text: "Tutti",
        value: -1,
      },
      tempSegnalazione: {
        id_documento: this.id_documento,
        id_documento_dettaglio: null,
        tipo: 0,
        quantita: 0,
        note: "",
      },
      impegni: [{ qnt_magazzino: 0 }],
      articoli: [],
      segnalazioni: [],
      posizioni: [],
      dialogEliminaArticolo: false,
      distinteSelected: [],
      placingStatus:[
          "Nessun articolo ubicato",
          "Parzialmente ubicato",
          "Completamente ubicato"
      ],
      statusIcons: [
        {
          color: "error",
          icon: "mdi-cancel",
          desc: "Quantità non sufficiente",
        },
        {
          color: "yellow accent-4",
          icon: "mdi-information",
          desc: "Parzialmente prelevato",
        },
        {
          color: "success",
          icon: "mdi-check",
          desc: "Completatmente prelevato",
        },
      ],
      tipi_segnalazione: [
        {
          tipo: 0,
          desc: "Mancanza Materiale",
        },
        {
          tipo: 1,
          desc: "Materiale NOK",
        },
        {
          tipo: 2,
          desc: "Codice illeggibile",
        },
      ],
      statusIconsI: [
        {
          color: "error",
          icon: "mdi-cancel",
          desc: "Non disponibile",
        },
        {
          color: "yellow accent-4",
          icon: "mdi-information",
          desc: "Parzialmente disponibile",
        },
        {
          color: "success",
          icon: "mdi-check",
          desc: "Completatmente disponibile",
        },
      ],
      urgenze: [
        {
          id: 0,
          icon: "mdi-arrow-down",
          color: "success",
          desc: "Bassa",
        },
        {
          id: 1,
          icon: "mdi-minus",
          color: "yellow accent-4",
          desc: "Media",
        },
        {
          id: 2,
          icon: "mdi-exclamation-thick",
          color: "error",
          desc: "Alta",
        },
      ],
      headers_placing: [
        {
          text: "Des. Articolo",
          value: "descrizione",
        },
        {
          text: "Cod. Articolo",
          value: "cod_articolo",
        },
        {
          text: "Quantita",
          value: "quantita",
        },
        {
          text: "Q.tà Ubicata",
          value: "qta_ubicata",
        },
        {
          text: "Stato",
          value: "statoPlacing",
        },
        {
          text: "Segnalazioni",
          value: "segnalazione",
        },
      ],
      headers: [
        /*{
          text: "Modifica",
          value: "modifica",
          sortable: false,
          width: "100px",
        },*/
        {
          text: "Des. Articolo",
          value: "descrizione",
        },
        {
          text: "Cod. Articolo",
          value: "cod_articolo",
        },
        {
          text: "Q.tà Ordine",
          value: "quantita",
        },
        {
          text: "Q.tà Prelevata",
          value: "qta_prelevata",
        },
        {
          text: "Stato prelievo",
          value: "giacenza",
        },
        {
          text: "Stato magazzino",
          value: "posizione",
        },
        {
          text: "Stato impegno",
          value: "impegno",
        },
        {
          text: "Segnalazioni",
          value: "segnalazione",
        },
        /*{
          text: "Elimina",
          value: "elimina",
          sortable: false,
          width: "100px",
        },*/
      ],
      commessaHeaders: [
        {
          text: "Cod. Commessa",
          value: "cod_commessa",
        },
        {
          text: "Des. Commessa",
          value: "des_commessa",
        },
        {
          text: "Cod. Articolo",
          value: "cod_art_commessa",
        },
        {
          text: "Des. Articolo",
          value: "des_art_commessa",
        },
        {
          text: "Cod. Componente",
          value: "cod_articolo",
        },
        {
          text: "Des. Componente",
          value: "descrizione",
        },
        {
          text: "Qnt Articolo",
          value: "qnt_commessa",
        },
        {
          text: "Qnt Componente",
          value: "quantita",
        },
      ],
      impegnoHeaders: [
        {
          text: "Ordine",
          value: "num_documento",
        },
        {
          text: "Urgenza",
          value: "urgenza",
        },
        {
          text: "Data",
          value: "data_documento",
        },
        {
          text: "Quantita",
          value: "qnt_impegno",
        },
        {
          text: "Stato Impegno",
          value: "stato",
        },
      ],
      posizioneHeaders: [
        {
          text: "Posizione",
          value: "path",
        },
        {
          text: "Lotto",
          value: "cod_lotto",
        },
        {
          text: "Tipo Posizione",
          value: "tipo",
        },
        {
          text: "Quantita",
          value: "quantita",
        },
      ],
      giacenzaHeaders: [
        {
          text: "Posizione",
          value: "path",
        },
        {
          text: "Lotto",
          value: "cod_lotto",
        },
        {
          text: "Quantita",
          value: "quantita",
        },
      ],
      tipiPosizione: ["Refilling", "Picking"],
      items: [1, 2, 3, 4, 5, 6],
      lista_tabella: [],
      tipi_segnalazioni: [],
    };
  },
  watch: {
    tipoSegnalazione(value) {
      if (value === "Codice illeggibile") {
        this.singleSelect = true;
      }
    },
  },
  mounted() {
    this.loadDistinta();
  },
  methods: {
    async terminaForzata() {
      await this.terminaOrdine();
      this.terminaDialog = false;
    },
    async terminaJSON() {
      await this.terminaOrdine();
      this.terminaDialog = false;
      var strJSON =
        "{cod_ordine: " +
        this.num_documento +
        ", ragione_sociale: " +
        this.rag_soc +
        "}";
      console.log(strJSON);

      /*const dlJSON = document.createElement("dlJSON");
      dlJSON.style.display = "none";
      document.body.appendChild(dlJSON);
      dlJSON.href = window.URL.createObjectURL(
        new Blob([strJSON], { type: "text/plain" })
      );
      dlJSON.setAttribute("download", "JSON.txt");
      dlJSON.click();
      window.URL.revokeObjectURL(dlJSON.href);
      document.body.removeChild(dlJSON);*/
    },
    async terminaOrdine() {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setstatodocumento",
          stato_doc: 4,
          id_documento: this.id_documento,
          token: localStorage.getItem("user_token"),
        },
      };

      await this.$store.dispatch("api", request).then((res) => {
        if (res.data.response === true) {
          this.$refs.SnackbarQV.print("success", "Ordine Terminato");
        } else {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore: Impossibile terminare ordine"
          );
        }
        this.loading = false;
      });
    },
    changeView() {
      if (this.viewMode == 0) {
        this.viewMode = 1;
      } else {
        this.viewMode = 0;
      }
    },
    showImpegno(item) {
      this.impegni = item.impegni;
      this.totImpegno = item.totImpegno;
      this.impegnoDialog = true;
    },
    changeFilters() {
      this.filtered = this.lista_tabella.filter(
        (item) =>
          (item.statoPreleva == this.filtro_giac.value ||
            this.filtro_giac.text == "Tutti") &&
          (item.statoDisponibilita == this.filtro_disp.value ||
            this.filtro_disp.text == "Tutti")
      );
    },
    showGiacenza(item) {
      this.giacenze = [];
      this.giacenzaDialog = true;
      this.loading = true;
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getstatogiacenza",
          id_articolo: item.id_articolo,
          id_documento: this.id_documento,
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.data.statusCode === 200) {
          this.giacenze = Array.from(res.data.result.Table1);
        }
        this.loading = false;
      });
    },
    getImmagini(id) {
      this.loading = true;
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getsegnalazioneimmagini",
          id_segnalazione: id,
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.data.statusCode === 200) {
          this.immagini = Array.from(res.data.result.immagini);
        }
        this.loading = false;
      });
    },
    showSegnalazione(item) {
      for (let i = 0; i < this.segnalazioni.length; i++) {
        if (
          this.segnalazioni[i].id_documento_dettaglio == item.id_documento_dettaglio
        ) {
          this.tempSegnalazione = Object.assign({}, this.segnalazioni[i]);
          break;
        }
      }
      this.getImmagini(this.tempSegnalazione.id_segnalazione);
      this.segnalazioneDettaglio = true;
    },
    toggleFilters() {
      this.changeFilters();
      this.showFilter = !this.showFilter;
    },
    showPosizioni(item) {
      this.posizioni = [];
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getposizioniarticoli",
          articoli: [{ id_articolo: item.id_articolo }],
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.data.statusCode === 200) {
            this.posizioni = Array.from(res.data.result[item.id_articolo]);
            this.$forceUpdate();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricar ei dati."
            );
          }
        })
        .catch((err) => {
          if (err) {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        });

      this.posizioneDialog = true;
    },

    /*salvaSegnalazione() {
      console.log(this.tempSegnalazione);
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setanmoalie",
          token: localStorage.getItem("user_token"),
          segnalazioni: [this.tempSegnalazione],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.SnackbarQV.print("success", "Segnalazione salvata.");
            for (let i = 0; i < this.articoli.length; i++) {
              if (
                this.articoli[i].id_documento_dettaglio ==
                this.tempSegnalazione.id_documento_dettaglio
              ) {
                this.articoli[i].segnalazione = true;
                this.$forceUpdate();
                break;
              }
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricar ei dati."
            );
          }
        })
        .catch((err) => {
          if (err) {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        });
    },*/

    gestisciPedane() {
      this.gestisci_pedane_dialog = true;
    },
    handleCloseGestPed() {
      this.gestisci_pedane_dialog = false;
    },
    async loadDistinta() {
      this.loading = true;

      //chiamata carica articoli
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getdocumento",
          token: localStorage.getItem("user_token"),
          id_documento: this.id_documento,
        },
      };

      await this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.codDocumento = res.data.documento[0].cod_documento;
            this.codPicking = res.data.documento[0].num_protocollo;
            this.rag_soc = res.data.documento[0].ragione_sociale;
            this.articoli = new Array();
            this.articoli = Array.from(res.data.documento[0].dettaglio);
            for (let i = 0; i < this.articoli.length; i++) {
              this.articoli[i].impegno = 0;
              if (this.articoli[i].qta_prelevata == 0) {
                this.articoli[i].statoPreleva = 0;
              } else if (
                this.articoli[i].quantita == this.articoli[i].qta_prelevata
              ) {
                this.articoli[i].statoPreleva = 2;
              } else {
                this.articoli[i].statoPreleva = 1;
              }
              //stato placing
              if(this.articoli[i].qta_ubicata == null){
                  this.articoli[i].qta_ubicata = 0;
              }
              if (this.articoli[i].qta_ubicata == 0) {
                this.articoli[i].statoPlacing = 0;
              } else if (
                this.articoli[i].quantita == this.articoli[i].qta_ubicata
              ) {
                this.articoli[i].statoPlacing = 2;
              } else {
                this.articoli[i].statoPlacing = 1;
              }
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          if (err) {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        });

      const request3 = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getposizioniarticoli",
          token: localStorage.getItem("user_token"),
          articoli: this.articoli,
        },
      };

      await this.$store.dispatch("api", request3).then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          for (let i = 0; i < this.articoli.length; i++) {
            this.articoli[i].statoDisponibilita = 2;
            this.articoli[i].posizioni = Array.from(
              res.data.result[this.articoli[i].id_articolo.toString()]
            );
            var tot = 0;
            for (
              let i2 = 0;
              i2 <
              res.data.result[this.articoli[i].id_articolo.toString()].length;
              i2++
            ) {
              const e =
                res.data.result[this.articoli[i].id_articolo.toString()][i2];
              tot += e.quantita;
            }
            if (tot < 1) {
              this.articoli[i].statoDisponibilita = 0;
            } else if (
              tot <
              this.articoli[i].quantita - this.articoli[i].qta_prelevata
            ) {
              this.articoli[i].statoDisponibilita = 1;
            }
          }
        } else {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        }
        this.lista_tabella = this.articoli;
        console.log(this.lista_tabella);
        console.log(this.articoli);
      });

      //chiamata carica segnalazioni
      const request2 = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getsegnalazioni",
          token: localStorage.getItem("user_token"),
          id_documento: this.id_documento,
        },
      };

      this.$store
        .dispatch("api", request2)
        .then((res) => {
          if (res.data.statusCode === 200) {
            this.segnalazioni = new Array();
            this.segnalazioni = Array.from(res.data.result.segnalazioni);
            for (let i = 0; i < this.segnalazioni.length; i++) {
              for (let i2 = 0; i2 < this.lista_tabella.length; i2++) {
                if (
                  this.segnalazioni[i].id_documento_dettaglio ==
                  this.lista_tabella[i2].id_documento_dettaglio
                ) {
                  this.lista_tabella[i2].segnalazione = true;
                }
              }
            }
            this.$forceUpdate();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          if (err) {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        });

      const request4 = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoloimpegno",
          token: localStorage.getItem("user_token"),
          articoli: this.articoli.map((a) => ({ id_articolo: a.id_articolo })),
        },
      };

      await this.$store.dispatch("api", request4).then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          for (let i = 0; i < this.articoli.length; i++) {
            this.articoli[i].statoImpegno = 2;
            this.articoli[i].impegni = Array.from(
              res.data.result[this.articoli[i].id_articolo.toString()]
            );

            this.articoli[i].totImpegno = 0;
            this.articoli[i].impegni.forEach((e) => {
                if(e.urgenza == null){
                    e.urgenza = 0;
                }
            });
            this.articoli[i].impegni.sort((a, b) =>
              a.urgenza == b.urgenza
                ? Date.parse(a.data_documento) < Date.parse(b.data_documento)
                : b.urgenza - a.urgenza
            );
            this.articoli[i].impegni.forEach((e) => {
              if (e.qnt_magazzino == null) {
                e.qnt_magazzino = 0;
              }
              if (
                e.qnt_impegno <=
                e.qnt_magazzino - this.articoli[i].totImpegno
              ) {
                e.stato = 2;
              } else if (e.qnt_magazzino - this.articoli[i].totImpegno > 0) {
                e.stato = 1;
              } else {
                e.stato = 0;
              }
              if (this.num_documento == e.num_documento) {
                this.articoli[i].impegno = e.stato;
              }
              this.articoli[i].totImpegno += e.qnt_impegno;
            });
          }
        } else {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        }
        this.lista_tabella = this.articoli;
        console.log(this.lista_tabella);
        console.log(this.articoli);
      });

      this.loading = false;
    },
    nuovaPedana() {},
    /*salvaSegnalazione() {
      if (this.tipoSegnalazione === null || this.tipoSegnalazione === "") {
        this.$refs.SnackbarQV.print("error", "Selezionare un tipo di segnalazione");

        return;
      }

      if (this.distinteSelected.length === 0) {
        this.$refs.SnackbarQV.print(
          "error",
          "Selezionare una o più righe da segnalare"
        );

        return;
      }

      if (this.tipoSegnalazione === "Codice illeggibile") {
        this.currentItem = this.distinteSelected[0];
        this.dialogPicking = true;
        return;
      }

      this.$refs.SnackbarQV.print("success", "Segnalazione segnalata");

      this.toggleGenerazioneSegnalazione();
    },*/
    /*salvaPicking() {
      let request = {
        controller: "Picking",
        method: "PUT",
        richiesta: {
          action: "",
          token: localStorage.user_token,
        },
      };

      this.$store.dispatch("api", request).then(async (res) => {
        if (res.status == 200) {
          this.$refs.SnackbarQV.print("success", "Picking salvata.");
        }
      });
    },*/

    salvaEditDialog() {
      console.log(JSON.stringify(this.currentItem));
    },
    showEditDialog(item) {
      this.currentItem = Object.assign({}, item);
      this.quantita = item.quantita_prelevata;

      this.edit_dialog_visible = true;
    },
    chiudiEditDialog() {
      this.edit_dialog_visible = false;
    },
    toggleGenerazioneSegnalazione() {
      this.distinteSelected = [];
      this.tipoSegnalazione = null;

      this.generazioneSegnalazione = !this.generazioneSegnalazione;
    },
    pickingItem() {
      this.dialogPicking = false;
      this.toggleGenerazioneSegnalazione();

      const item = this.lista_tabella.splice(
        this.lista_tabella.indexOf(this.currentItem),
        1
      )[0];
      if (item.quantita_prelevata == item.quantita) {
        item.class = "green-background";
      } else {
        item.class = "purple-background";
      }
      this.lista_tabella.push(item);
    },
    showDeleteArticolo(item) {
      this.currentArticolo = item;
      this.dialogEliminaArticolo = true;
    },
    deleteArticolo() {
      this.dialogEliminaArticolo = false;

      this.lista_tabella = this.lista_tabella.filter((el) => {
        console.log(this.currentArticolo.id);
        return el.id != this.currentArticolo.id;
      });
    },
  },
};
</script>

<style>
.green-background {
  background: #a5e5a5 !important;
}
.purple-background {
  background: #c874ce !important;
}

.list-move {
  transition: transform 1s;
}

.segnalazione-select .v-input__slot {
  background: white !important;
}
</style>
